"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.showCustomDialog = exports.closeDialog = exports.showDialog = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _dialogRegistry = require("../../dialogRegistry");

var _NotificationsActions = require("../../models/NotificationsActions");

var _notificationsRegistry = require("../notificationsRegistry");

var showDialog = function showDialog(state, action) {
  var dialog = action.payload;

  if (dialog === undefined) {
    return state;
  }

  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    dialog: dialog
  });
};

exports.showDialog = showDialog;

_notificationsRegistry.notificationsRegistry.add(_NotificationsActions.NotificationsActions.showDialog, showDialog);

var closeDialog = function closeDialog(state, action) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    dialog: undefined
  });
};

exports.closeDialog = closeDialog;

_notificationsRegistry.notificationsRegistry.add(_NotificationsActions.NotificationsActions.dialogSubmitted, closeDialog);

_notificationsRegistry.notificationsRegistry.add(_NotificationsActions.NotificationsActions.dialogCanceled, closeDialog);

var showCustomDialog = function showCustomDialog(state, action) {
  if (!_dialogRegistry.dialogRegistry.hasShowAction(action.type)) {
    return state;
  }

  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    dialog: {
      type: action.type,
      parameters: action.payload
    }
  });
};

exports.showCustomDialog = showCustomDialog;

_notificationsRegistry.notificationsRegistry.add(showCustomDialog);